<template>
  <div class="main-content" id="panel">
    <div class="header bg-primary pb-6">
      <div class="container-fluid">
        <div class="header-body">
          <div class="row align-items-center py-4">
            <div class="col-lg-6 col-7">
              <h2>Offering Feed Settings</h2>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid mt--6">
      <div class="row justify-content-md-center upload">
        <div class="col-xl-7">
          <div class="card p-3">
            <div class="d-flex bd-highlight"></div>
            <div class="d-flex bd-highlight">
              <div>
                <h4 style="color: #0087d4">USER SETTINGS</h4>
              </div>
            </div>
            <form class="mt-4">
              <div class="form-row settings">
                <div class="form-group col-md-4">
                  <label for="inputEmail4">
                    OFFER NOTIFICATION THRESHOLD
                    <span
                      class="hint"
                      data-toggle="tooltip"
                      data-placement="right"
                      title="Set the price difference threshold for sending the next notification."
                    >
                      <i class="fa fa-info-circle" style="color: #ffa300"></i>
                    </span>
                  </label>
                  <input
                    type="number"
                    class="form-control"
                    v-model="offeringFeedPriceDiffThresholdNotif"
                  />
                </div>
                <div class="form-group col-md-4">
                  <label for="inputEmail4">
                    OFFER REDISPLAY THRESHOLD
                    <span
                      class="hint"
                      data-toggle="tooltip"
                      data-placement="right"
                      title="Set the price difference threshold to redisplay hidden offers."
                    >
                      <i class="fa fa-info-circle" style="color: #ffa300"></i>
                    </span>
                  </label>
                  <input
                    type="number"
                    class="form-control"
                    v-model="offeringFeedPriceDiffThresholdListing"
                  />
                </div>
                <div class="form-group col-md-4">
                  <label for="inputEmail4">
                    MATERIAL EVENT LOOK UP PERIOD
                    <span
                      class="hint"
                      data-toggle="tooltip"
                      data-placement="right"
                      title="Enter the number of days to check for the availability of material events."
                    >
                      <i class="fa fa-info-circle" style="color: #ffa300"></i>
                    </span>
                  </label>
                  <div class="input-group">
                    <input
                      type="number"
                      class="form-control"
                      v-model="offeringFeedMaterialEventDayLimit"
                      @input="offeringFeedMaterialEventDayLimit = $event.target.value.replace(/\D/g, '')"
                    />
                    <div class="input-group-append">
                      <span class="input-group-text">days</span>
                    </div>
                  </div>
                  <!-- <input type="number" class="form-control"
                                        v-model="offeringFeedMaterialEventDayLimit" /> -->
                </div>
              </div>
              <div class="d-flex bd-highlight">
                <div>
                  <h4 style="color: #0087d4">GLOBAL SETTINGS</h4>
                </div>
              </div>
              <div class="form-row settings" v-if="isAdmin">
                <div class="form-group col-md-6">
                  <label for="inputEmail4">
                    PUSH NOTIFICATION DELAY
                    <span
                      class="hint"
                      data-toggle="tooltip"
                      data-placement="right"
                      title="Specify the time to wait before sending the push notification for a price change following the previous alert."
                    >
                      <i class="fa fa-info-circle" style="color: #ffa300"></i>
                    </span>
                  </label>
                  <div class="input-group">
                    <input
                      type="number"
                      class="form-control"
                      id="offeringFeedPushInterval"
                      v-model="offeringFeedPushInterval"
                    />
                    <div class="input-group-append">
                      <span class="input-group-text">minutes</span>
                    </div>
                  </div>
                </div>
                <div class="form-group col-md-6">
                  <label for="inputEmail4">
                    EMAIL NOTIFICATION DELAY
                    <span
                      class="hint"
                      data-toggle="tooltip"
                      data-placement="right"
                      title="Specify the time to wait before sending the email notification for a price change following the previous alert."
                    >
                      <i class="fa fa-info-circle" style="color: #ffa300"></i>
                    </span>
                  </label>
                  <div class="input-group">
                    <input
                      type="number"
                      class="form-control"
                      id="offeringFeedEmailInterval"
                      v-model="offeringFeedEmailInterval"
                    />
                    <div class="input-group-append">
                      <span class="input-group-text">minutes</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="d-flex bd-highlight mt-4">
                <div v-if="isAdmin && isDev">
                  <h4 style="color: #0087d4">EMAIL SIGNATURE</h4>
                </div>
              </div>

              <div class="form-row settings align-items-center" v-if="isAdmin && isDev">
                <!-- Signature Preview -->
                <div class="form-group col-md-6 text-center">
                  <label class="d-block mb-2 font-weight-bold"
                    >Current Signature</label
                  >
                  <div class="border rounded p-2 bg-light" >
                    <img
                        v-if="!imageLoading"
                      :src="signaturePreview"
                      alt="Email Signature"
                      class="img-fluid rounded shadow-sm"
                      style="max-width: 100%; height: auto"
                    />
                     <img v-if="imageLoading" src="@/assets/img/loader.svg" alt="Loading..." width="30" />
                  </div>
                </div>

                <!-- Upload Section -->
                <div class="form-group col-md-6">
                  <label for="emailSignatureUpload" class="font-weight-bold">
                    Upload New Signature:
                  </label>
                  <div class="input-group">
                    <div class="custom-file">
                      <input
                        type="file"
                        class="custom-file-input"
                        id="emailSignatureUpload"
                        accept="image/png, image/jpeg"
                        @change="onSignatureUpload"
                      />
                      <label
                        class="custom-file-label"
                        for="emailSignatureUpload"
                      >
                        Choose file...
                      </label>
                    </div>
                  </div>
                  <small class="form-text text-muted mt-1">
                    Accepted formats: JPG, PNG. Max size: 2MB.
                  </small>
                  <!-- <div v-if="uploadError" class="text-danger mt-2">
      {{ uploadError }}
    </div> -->
                  <!-- 
    <div v-if="loading" class="mt-2 text-center">
      <img src="@/assets/img/loader.svg" alt="Loading..." width="30" />
    </div>
    <div v-if="uploadError" class="text-danger mt-2">
      {{ uploadError }}
    </div>
    <div v-if="uploadSuccess" class="text-success mt-2">
      {{ uploadSuccess }}
    </div> -->
                </div>
              </div>

              <div v-if="loading" class="loader">
                <img src="@/assets/img/loader.svg" alt="" />
              </div>
              <!-- <span class="text-warning" v-if="showWarningMessage && isAutoBidder">{{ warningMessage }}</span> -->
              <div class="form-group col-md-12 text-center">
                <button
                  @click="saveSettings()"
                  type="button"
                  class="btn btn-success"
                >
                  SAVE
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import config from "@/config";
import authService from "@/authService";


export default {
    name: "basetting",
    components: {

    },
    data() {
        return {
            loading: false,
            imageLoading: false,
            offeringFeedPriceDiffThresholdNotif: "",
            offeringFeedPriceDiffThresholdListing: "",
            offeringFeedPushInterval: "",
            offeringFeedEmailInterval: "",
            isAdmin: false,
            offeringFeedMaterialEventDayLimit : 0,
            signaturePreview: null,
            fileChanged: false,
            fileForUpload : null
        };
    },
    methods: {
        onSignatureUpload(event) {
            const file = event.target.files[0];
            this.fileForUpload = file;

            if (!file) return;

            if (!["image/jpeg", "image/png"].includes(file.type)) {
            this.uploadError = "Only JPG and PNG files are allowed.";
            return;
            }

            if (file.size > 2 * 1024 * 1024) {
            this.uploadError = "File size exceeds 2MB.";
            return;
            }

            this.uploadError = "";
            this.uploadSuccess = "";
            this.loading = true;

            const reader = new FileReader();
            reader.onload = () => {
                this.signaturePreview = reader.result;
                this.loading = false;
                this.uploadSuccess = "Signature uploaded successfully!";
                this.fileChanged = true;
            };
            reader.readAsDataURL(file);
        },
        saveSettings() {
            if(this.isAdmin && this.fileChanged && this.isDev){
                this.saveSignature()
            }
            let dataToSend = [
                {
                    "setting": "OFFERING_FEED_PRICE_DIFF_THRESHOLD_NOTIF",
                    "dataType": "NUMERIC",
                    "value": this.offeringFeedPriceDiffThresholdNotif,
                    "cognitoSub": authService.getUser().cognitoSub
                },
                 {
                    "setting": "OFFERING_FEED_PRICE_DIFF_THRESHOLD_LISTING",
                    "dataType": "NUMERIC",
                    "value": this.offeringFeedPriceDiffThresholdListing,
                    "cognitoSub": authService.getUser().cognitoSub
                },
                {
                    "setting": "OFFERING_FEED_PUSH_NOTIF_INTERVAL",
                    "dataType": "NUMERIC",
                    "value": this.offeringFeedPushInterval,
                    "updateByCognitoSub": authService.getUser().cognitoSub
                },
                {
                    "setting": "OFFERING_FEED_EMAIL_NOTIF_INTERVAL",
                    "dataType": "NUMERIC",
                    "value": this.offeringFeedEmailInterval,
                    "updateByCognitoSub": authService.getUser().cognitoSub
                },
                {
                    "setting": "OFFERING_FEED_MATERIAL_EVENT_CHECK_DAY_LIMIT",
                    "dataType": "NUMERIC",
                    "value": this.offeringFeedMaterialEventDayLimit,
                    "cognitoSub": authService.getUser().cognitoSub
                }
            ]
            this.loading = true;
            this.loading = false;
            const auth = {
                headers: { 'org-token': authService.getOrgToken() }
            };
            this.$http
                .post(
                    config.baseUrlBidSide +
                    "/tradebook/setting", dataToSend,
                    auth
                )
                .then(() => {
                    this.loading = false;
                    this.$alert("Saved successfully ", "", "success")
                })
                .catch(e => {
                    console.log(e);
                });
        },
        saveSignature() {
            const auth = {
                headers: {
                'org-token': authService.getOrgToken(),
                }
            };
            const formData = new FormData();
            formData.append("signatureImage", this.fileForUpload); // 👈 use actual File object

            this.$http
                .post(
                "https://u9f6m40hl4.execute-api.us-east-1.amazonaws.com/dev-env-public/offering-feed/replace-signature-image",
                formData,
                auth
                )
        },
        async getSignaturePreview() {
           if (!this.isAdmin || !this.isDev) {
                return; // Exit if not admin or not in dev environment
            }
            this.imageLoading = true;
            try {
                const response = await this.$http.get(
                "https://u9f6m40hl4.execute-api.us-east-1.amazonaws.com/dev-env-public/offering-feed/signature-image",
                { responseType: "arraybuffer" } // 👈 important
                );

                // Convert ArrayBuffer to Base64
                const base64String = this.arrayBufferToBase64(response.data);
                this.signaturePreview = `data:image/png;base64,${base64String}`;

            } catch (error) {
                console.error("Error loading signature image:", error);
            } finally {
                this.imageLoading = false;
            }
            },
            arrayBufferToBase64(buffer) {
                let binary = "";
                const bytes = new Uint8Array(buffer);
                const len = bytes.byteLength;
                for (let i = 0; i < len; i++) {
                    binary += String.fromCharCode(bytes[i]);
                }
                return window.btoa(binary);
            },
        getUserSetting() {
            this.loading = true;
            const auth = {
                headers: { 'org-token': authService.getOrgToken() }
            };
            this.$http
                .get(
                    config.baseUrlBidSide +
                    "/tradebook/setting-list?cognitoSub=" + authService.getUser().cognitoSub,
                    auth
                )
                .then(result => {
                    this.userSettings = result.data;
                    this.userSettings.forEach(element => {
                        if (element.setting == "OFFERING_FEED_PRICE_DIFF_THRESHOLD_NOTIF") {
                            this.offeringFeedPriceDiffThresholdNotif = element.value
                        }
                        if (element.setting == "OFFERING_FEED_PRICE_DIFF_THRESHOLD_LISTING") {
                            this.offeringFeedPriceDiffThresholdListing = element.value
                        }
                        if (element.setting == "OFFERING_FEED_PUSH_NOTIF_INTERVAL") {
                            this.offeringFeedPushInterval = element.value
                        }
                        if (element.setting == "OFFERING_FEED_EMAIL_NOTIF_INTERVAL") {
                            this.offeringFeedEmailInterval = element.value
                        }
                        if (element.setting == "OFFERING_FEED_MATERIAL_EVENT_CHECK_DAY_LIMIT") {
                            this.offeringFeedMaterialEventDayLimit = element.value
                        }

                    });
                    this.loading = false;
                })
                .catch(e => {
                    console.log(e);
                });
        },
    },
    mounted() {
        this.getUserSetting();
        this.getSignaturePreview();
        this.$cognitoAuth.getIdToken((err, result) => {
            if (err) {
                console.log("accessToken is not found", err);
            } else {
                this.accessToken = result;
                this.$cognitoAuth.getUserGroup((err, role) => {
                    if (err) {
                        console.log("accessToken is not found", err);
                    } else {
                        this.tenantName = role[0].split("-")[0];
                        var roleArray = role.map(item => {
                            return item.split("-")[1];
                        })
                        roleArray.includes('Admin') ? this.isAdmin = true : this.isAdmin = false;
                    }
                });


            }
        });
    }
}
</script>
